<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import Input from './Input.vue'

import { cn } from '@/utils/shadcn/lib/utils.ts'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
    <Input
        data-slot="input-group-control"
        :class="cn(
            'flex-1 rounded-none border-0 py-0 mt-[1px] bg-transparent shadow-none focus-visible:ring-0',
            props.class,
        )"
    />
</template>
